/**
 * Mapbox configuration constants
 */

// Mapbox style URL for REKKIE Maps v2.3.37 - 3D
export const MAPBOX_STYLE = 'mapbox://styles/andersonpaac/cmvq3y4da00kg01r797c15roo';
